<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="770">
    <v-card>
        <v-card-title>{{state=='new'?'ADD':'EDIT'}} MODIFIED SALES</v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col cols="12" v-if="state=='new'">
                   <v-text-field
                            v-model="kilos_distribute"
                            @focus="kilos_distribute=''"
                            @keyup="setKilos()"
                            label="Total Kilos to be distributed"
                        ></v-text-field>
                </v-col>
                <v-col md='6'>
                         
                        <v-autocomplete
                        v-model="sales.supplier"
                        :items="fishcars"
                        item-text="name"
                        :rules="textRules"
                        :disabled="ALLOW"
                        required
                        item-value="id"
                            @change="getSupplies(), getSequence()"
                        label="Fishcars"
                        ></v-autocomplete>
                    
                        <v-autocomplete
                        v-model="sales.customer"
                        :disabled="ALLOW"
                        :items="customers"
                        item-text="firstname"
                            :hint="`Parent: ${customer.parent_name}`"
                            persistent-hint
                        item-value="id"
                        @change="setCustomer()"
                        label="Select Customer"
                         :rules="textRules"
                        required
                        ></v-autocomplete>
                        <v-autocomplete
                            v-model="fish"
                            :disabled="ALLOW"
                            label="Kind"
                            :items="supplies"
                            item-value='id'
                            item-text='name'
                            return-object
                             :rules="textRules"
                        required
                        ></v-autocomplete>
                
                        <v-text-field
                            v-model="sales.kilos"
                            @keyup="serviceCharge()"
                            label="Kilos"
                             :rules="textRules"
                             :disabled="ALLOW"
                        required
                        ></v-text-field>
                            <v-text-field
                            v-model="sales.price"
                            label="Price per kilo"
                             :rules="textRules"
                             :disabled="ALLOW"
                        required
                        ></v-text-field>
                        
                </v-col>
                <v-col md='6'>
                    
                      <v-text-field
                            v-model="SEQUENCE"
                            label="Sequence"
                            v-if="state=='new'"
                            :disabled="ALLOW"
                        ></v-text-field>
                        <v-text-field
                          v-else
                            v-model="sales.sequence"
                            :disabled="ALLOW"
                            label="Sequence"
                        ></v-text-field>
                        <v-text-field
                        v-model="sales.service_charge"
                        label="Service Charge"
                        :disabled="ALLOW"
                        ></v-text-field>

                        <v-text-field
                            v-model="sales.trucking_fee"
                            :disabled="ALLOW"
                            label="Trucking Fee"
                        ></v-text-field>
                        <v-autocomplete
                        v-model="sales.status"
                        :items="statuses"
                         :rules="textRules"
                         :disabled="ALLOW"
                        required
                        label="Status"
                        ></v-autocomplete>
                        <v-autocomplete
                        v-model="sales.payment_type"
                         :rules="textRules"
                        required
                        :items="PAYMENT_TYPES"
                        label="Type"
                        ></v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="state=='new'">
                   <v-text-field
                            v-model="REMAINNG"
                            label="Remaining"
                            :disabled="true"
                        ></v-text-field>
                </v-col>
              </v-row>
             </v-form>
             <v-divider/>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('cancel')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success" :loading="loading" rounded  depressed  @click="validate()" v-if="SHOWBTN">{{BTN_TEXT}}</v-btn>
            <v-btn  small color="info" rounded  depressed  @click="emitToParent('cancel')" v-else>DONE</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
export default {
  mixins: [API_MIXINS],
  props: {
    show: {
        type: Boolean,
        default: false
    },
    sales: {
         type: Object,
            default: ()=>{ return {} }
    },
    fishcars: {
         type: Array,
            default: ()=>{ return [] }
    },
    customers: {
         type: Array,
            default: ()=>{ return [] }
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
    loading: false,
      valid: true,
      supplies: [],
      kilos_distribute: 0,
      kilos_distributed:0,
      fishcar: {},
      fish: {},
      customer: {},
      settings:[],
      statuses:['for weighing', 'for payment', 'paid'],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
    PAYMENT_TYPES(){
         if(this.$session.get('role') == 'cashier'){
          return  ['credit']
        } return   ['cash', 'credit']
    },
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      SALES_AMOUNT(){
          var amount = this.$IsNum(this.sales.kilos) * this.$IsNum(this.sales.price)
          return amount + this.$IsNum(this.sales.trucking_fee) + this.$IsNum(this.sales.service_charge) 
      },
      SEQUENCE() {
          return this.state == 'new'?this.$store.state.sequence:this.sales.sequence
      },
      REMAINNG() {
        return this.$IsNum(this.$store.state.kilos_to_distribute) - this.$IsNum(this.kilos_distributed)
      },
      SHOWBTN(){
        if(this.state == 'update') {
          return true
        } else {
            return this.REMAINNG>0?true:false
        }
      },
      ALLOW(){
        if(this.$session.get('role') == 'cashier'){
          return true
        } return false
      }
  },
  watch: {
    show () {
      if(this.show == true) {
          this.getSupplies()
          this.loadSetting()
          
          setTimeout(()=> {
            this.setCustomer()
              this.setFish()
          }, 500)
      } else {
        this.kilos_distribute = 0
        this.kilos_distributed = 0
      }
    }
  },
  methods: {
     ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setKilosToDistribute']),

     setKilos(){
       this.setKilosToDistribute(this.kilos_distribute)
     },
      setFish() {
        this.fish  = {}
        for(var i= 0;i< this.supplies.length;i++) {
            if(this.sales.product == this.supplies[i].id) {
                this.fish = this.supplies[i]
            }
        }
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.emitToParent(this.state)
          setTimeout(()=>{
             this.loading = false
          }, 800)
        }
      },
    emitToParent (action) {
        this.sales.name= this.fish.name
        this.sales.product = this.fish.id
        this.sales.sequence = this.state == "new" ? this.$IsNum(this.sequence) : this.$IsNum(this.sales.sequence)
           
        this.sales.amount= this.SALES_AMOUNT.toString()

        console.log(this.state)
        if(action == 'new') {
           // this.ADD_SALES(this.sales)
            this.kilos_distributed += this.$IsNum(this.sales.kilos)
        } else if(action == 'update') {
            //this.SAVE_SALES(this.sales)
             this.$emit('DialogEvent', {action: action, sales: this.sales})
        } else {
             this.$emit('DialogEvent', {action: action, sales: {}})
        }
    },
    serviceCharge(){
            if(this.customer.evat) {
                this.sales.service_charge = (this.$IsNum(this.sales.kilos) * this.$IsNum(this.getSettingVal('service_charge'))).toString()
            } else {
                this.sales.service_charge = '0'
            }
            this.sales.trucking_fee = this.getSettingVal('trucking_fee')
    },
     getSupplies: function() {
        let date = this.state == 'update'? this.$moment(this.sales.date).format('YYYY-MM-DD'):this.$moment().format('YYYY-MM-DD')
        this.$http.post("product/query_by_supplier", JSON.stringify({date: date,supplier: this.sales.supplier})).then(response => {
                 response.data.data != null?this.supplies = response.data.data:this.supplies = []
          }).catch(e => {
           console.log(e.data)
       })
    },
    loadSetting() {
          this.$http.post("setting/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.settings = response.data.data:this.settings = []
          }).catch(e => {
           console.log(e.data)
         })
      },
      getSettingVal(name) {
          for(var i =0;i<this.settings.length;i++) {
              if(this.settings[i].name == name) {
                  return this.settings[i].value
              }
          }
          return false
      },
      setCustomer(){
          for(var i =0;i<this.customers.length;i++) {
              if(this.customers[i].id == this.sales.customer) {
                 this.customer = this.customers[i]
                 this.customer.credit == 'enabled'?this.sales.payment_type='credit':this.sales.payment_type='cash'
                 break
              }
          }
      },
      getSequence() {
          if(this.state == 'new') {
             this.GET_SEQUENCE(this.sales.supplier)
             // this.sales.sequence = this.SEQUENCE
          }
      }
  }
}
</script>
